import React from 'react';
import Head from 'next/head';

export const MixiSidebar = () => {
  return (
    <>
      <Head>
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function() {
                var sc = document.createElement('script'); sc.type = 'text/javascript'; sc.async = true;
                sc.src = '//mixi.media/data/js/92003.js'; sc.charset = 'utf-8';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(sc, s);
              }());
            `,
          }}
          defer
          key="MixiSidebar"
          type="text/javascript"
        />
      </Head>
      <div id="unit_92003">
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <a href="https://mixi.media/" rel="nofollow"></a>
      </div>
    </>
  );
};

export default MixiSidebar;
